var map = {
	"./external/buy-phone/buyer.module": [
		"./src/app/external/buy-phone/buyer.module.ts",
		"default~external-buy-phone-buyer-module~external-repair-repair-module",
		"external-buy-phone-buyer-module"
	],
	"./external/chat-section/chat.module": [
		"./src/app/external/chat-section/chat.module.ts",
		"external-chat-section-chat-module"
	],
	"./external/compaire/compaire.module": [
		"./src/app/external/compaire/compaire.module.ts",
		"external-compaire-compaire-module"
	],
	"./external/diagnose/diagnose.module": [
		"./src/app/external/diagnose/diagnose.module.ts",
		"external-diagnose-diagnose-module"
	],
	"./external/notification/notification.module": [
		"./src/app/external/notification/notification.module.ts",
		"external-notification-notification-module"
	],
	"./external/recycle-history/recycleHistory.module": [
		"./src/app/external/recycle-history/recycleHistory.module.ts",
		"common",
		"external-recycle-history-recycleHistory-module"
	],
	"./external/recycle/recycle.module": [
		"./src/app/external/recycle/recycle.module.ts",
		"common",
		"external-recycle-recycle-module"
	],
	"./external/repair/repair.module": [
		"./src/app/external/repair/repair.module.ts",
		"default~external-buy-phone-buyer-module~external-repair-repair-module",
		"external-repair-repair-module"
	],
	"./external/sell/sell.module": [
		"./src/app/external/sell/sell.module.ts",
		"external-sell-sell-module"
	],
	"./external/setting/setting.module": [
		"./src/app/external/setting/setting.module.ts",
		"external-setting-setting-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;